@if (expandFilterDrawer$ | async) {}
<ng-container *ngIf="gridView$ | async as view">
  <div class="pages-container w-screen h-screen flex">
    @if (view !== "medium" && view !== "small") {
      <div class="pages-side-menu-bar">
        <z-side-menu-bar
          [settingURL]="configurations().settingRoute"
          [profile]="configurations().profile"
          [navigationList]="navigationList"
          [dashboardRoutes]="dashboardRoutes()"
          [homeButton]="configurations().homeButton"
          [settingsRoutes]="settingsRoutes()"
          [tools]="tools()"
          [hideTools]="configurations().hideTools"
        />
      </div>
      <div class="pages-side-menu">
        <z-side-menu [logoUrl]="configurations().logoUrl" />
      </div>
    }
    <main class="flex flex-column flex-1 overflow-hidden">
      <div class="pages-top-header">
        <z-top-header [logoUrl]="configurations().logoUrl">
          <div
            ngProjectAs="top-header-notification-section"
            class="flex align-items-center"
          >
            <ng-content select="notification-section-template" />
            @if (view === "medium" || view === "small") {
              <button
                class="filters-menu-toggle"
                type="button"
                [ngClass]="{ active: isFiltersMenuOpened() }"
                (click)="expandFilters()"
              >
                <em class="ph ph-list"></em>
              </button>
            }
          </div>
          @if (
            configurations().hasHeaderFilters &&
            view !== "medium" &&
            view !== "small"
          ) {
            <div ngProjectAs="top-header-filters-section">
              <z-bc-top-header-filters
                [regions]="regions()"
                [locations]="locations()"
                [(selectedLocations)]="selectedLocations"
                [(selectedRegions)]="selectedRegions"
                (locationsFilters)="filter()"
              />
            </div>
          }
        </z-top-header>
      </div>
      <div
        class="main-section flex flex-1 h-full overflow-y-auto overflow-x-hidden"
      >
        @if (view === "medium" || view === "small") {
          <z-side-menu-drawer
            [settingURL]="configurations().settingRoute"
            [profile]="configurations().profile"
            [navigationList]="navigationList"
            [dashboardRoutes]="dashboardRoutes()"
            [settingsRoutes]="settingsRoutes()"
            [homeButton]="configurations().homeButton"
            [tools]="tools()"
            [maxWidth]="'260px'"
            [hideTools]="configurations().hideTools"
            class="st-side-menu-drawer"
          />
        }
        <div class="pages-content flex-1 h-full overflow-auto">
          <ng-content select="page-content" />
        </div>
        @if (view === "medium" || view === "small") {
          @if (configurations().hasHeaderFilters) {
            <z-mobile-right-menu
              class="ml-auto"
              [maxWidth]="'260px'"
            >
              <div
                ngProjectAs="top-header-filters-section-mobile"
                class="h-full"
              >
                <z-mobile-header-filters
                  [regions]="regions()"
                  [locations]="locations()"
                  [(selectedLocations)]="selectedLocations"
                  [(selectedRegions)]="selectedRegions"
                  (locationsFilters)="filter()"
                />
              </div>
            </z-mobile-right-menu>
          }
        }
      </div>
    </main>
  </div>
</ng-container>
